import Vue from 'vue'

export const notifySuccess = async (message) => Vue.swal({ icon: 'success', text: message, timer: 3000, showConfirmButton: false })
export const notifyError = async (message) => Vue.swal({ icon: 'error', text: message, timer: 3000, showConfirmButton: false })